import API from "../../../../../global/api";



export const requestAddRestaurant = () => {
    return {
        type: "REQUEST_ADD_RESTAURANT",
    };
};
export const successAddRestaurant = (data) => {
    return {
        type: "SUCCESS_ADD_RESTAURANT",
        payload: data,
    };
};
export const errorAddRestaurant = () => {
    return {
        type: "ERROR_ADD_RESTAURANT",
    };
};
export const addRestaurant = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddRestaurant());
        API.post(`/company/add-company`, data).then((res) => {
            dispatch(successAddRestaurant(data));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorAddRestaurant());
            showErrorAlert(error.response.data.message || "Something went wrong");
        })
    };
};


export const requestRestaurantData = () => {
    return {
        type: "REQUEST_RESTAURANT_GET_DATA",
    };
};
export const successRestaurantGetData = (data) => {
    return {
        type: "SUCCESS_RESTAURANT_GET_DATA",
        payload: data,
    };
};
export const errorRestaurantGetData = () => {
    return {
        type: "ERROR_RESTAURANT_GET_DATA",
    };
};
export const getRestaurantData = () => {
    return (dispatch) => {
        dispatch(requestRestaurantData());
        API.get(`/company/get-companies?page=0&limit=1000`).then((res) => {
            let getData = res.data;
            dispatch(successRestaurantGetData(getData));
        }).catch((error) => {
            dispatch(errorRestaurantGetData());
        })
    };
};


export const DeleteRequestRestaurant = () => {
    return {
        type: "DELETE_REQUEST_RESTAURANT",
    };
};
export const DeleteSuccessRestaurant = (user_id) => {
    return {
        type: "DELETE_SUCCESS_RESTAURANT",
        user_id: user_id,
    };
};
export const DeleteErrorRestaurant = () => {
    return {
        type: "DELETE_ERROR_RESTAURANT",
    };
};
export const deleteRestaurant = (vendorId) => {
    return dispatch => {
        dispatch(DeleteRequestRestaurant());
        API.delete(`/company/delete-company/${vendorId}`).then(res => {
            dispatch(DeleteSuccessRestaurant(vendorId))
        }).catch((error) => {
            dispatch(DeleteErrorRestaurant())
        });
    }
};


export const UpdateRequestRestaurant = () => {
    return {
        type: "UPDATE_REQUEST_RESTAURANT",
    };
};
export const UpdateSuccessRestaurant = (data) => {
    return {
        type: "UPDATE_SUCCESS_RESTAURANT",
        payload: data,
    };
};
export const UpdateErrorRestaurant = () => {
    return {
        type: "UPDATE_ERROR_RESTAURANT",
    };
};
export const updateRestaurant = (data, oldData) => {
    return dispatch => {
        dispatch(UpdateRequestRestaurant());
        API.put(`/company/update-company/${oldData._id}`, {
            restaurantName: data.restaurantName,
            restaurantLocation: data.restaurantLocation,
            restaurantDesc: data.restaurantDesc,
            tax: data.tax,
            ntn: data.ntn,
            taxType: data.taxType,
            praTaxCash: data.praTaxCash,
            praTaxCard: data.praTaxCard,
            fbrTaxCash: data.fbrTaxCash,
            fbrTaxCard: data.fbrTaxCard,
            email: data.email,
            phone: data.phone,
            strn: data.strn,
        }, {
        }).then(res => {
            dispatch(UpdateSuccessRestaurant([data]))
        }).catch((error) =>
            dispatch(UpdateErrorRestaurant()));
    }
};